import * as yup from 'yup';
import {
  addOptionalToSchema,
  optionalNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

export const createPracticeSchema = yup.object().shape({
  name: requiredNameSchema,
  organization_id: yup.string(),
  partner_id: yup.string().required(requiredErrorMessage),
  external: yup.boolean().required(requiredErrorMessage),
  google_places_id: yup.string().required(requiredErrorMessage),

  street: requiredNameSchema,
  suite: optionalNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(requiredErrorMessage),
  county: optionalNameSchema,
  phone_number: addOptionalToSchema(phoneSchema),
  fax_number: addOptionalToSchema(phoneSchema),
});
